module.exports = __webpack_public_path__ + "static/media/Icon-info-blue-regular.397999ea.svg";